{
  "column": {
    "active": "Active",
    "company": "Company",
    "createdAt": "Created at",
    "email": "E-Mail",
    "firstName": "First name",
    "lastName": "Last name",
    "name": "Name",
    "roles": "Roles",
    "salutation": "Salutation",
    "title": "Title"
  },
  "label": {
    "addUser": "Add User",
    "cancel": "Cancel",
    "clearFilter": "Clear filter",
    "delete": "Delete",
    "errorDeleting": "An error occurred while deleting.",
    "errorHeader": "Error",
    "invalidData": "Invalid data",
    "onboardingMailError": "An error occurred while sending the onboarding mail.",
    "onboardingMailSent": "The onboarding mail was sent successfully.",
    "save": "Save",
    "sendOnboardingMail": "Send onboarding mail",
    "successHeader": "Success",
    "successfullyDeleted": "The entry was successfully deleted.",
    "successfullyDeletedHeader": "Successfully deleted"
  },
  "message": {
    "noUserData": "No user data available."
  },
  "placeholder": {
    "search": "Search",
    "selectAll": "Select all",
    "selectRole": "Select role"
  },
  "user": {
    "create": "Create User",
    "createFailed": "Failed to create user.",
    "created": "User created successfully.",
    "deleteConfirmMessage": "Are you sure you want to delete this user?",
    "deleteHeader": "Delete User",
    "edit": "Edit User",
    "updateFailed": "Failed to update user.",
    "updated": "User updated successfully."
  }
}